import React, { useRef, useEffect } from 'react';
import './Feature.css';
import Item from '../Item/Item';
import { useState} from 'react';
import { useNavigate } from 'react-router-dom';
import arrow from '../../assets/arrow.png';

const Feature = () => {
  const databaseUrl = process.env.REACT_APP_DATABASE_URL;
  const [featureProducts, setFeatureProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFeatureProducts = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${databaseUrl}/featureproducts`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setFeatureProducts(data); // Set the fetched data to state
      } catch (error) {
        console.error("Error fetching feature products:", error);
      }
      setIsLoading(false);
    };

    fetchFeatureProducts();
  }, [databaseUrl]); // Re-run if databaseUrl changes

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const handleScroll = () => {
      clearTimeout(window.scrollTimeout);
      window.scrollTimeout = setTimeout(() => {
        const container = scrollContainer;
        const items = container.querySelectorAll('.item');
        const containerRect = container.getBoundingClientRect();
        const containerCenterX = containerRect.left + containerRect.width / 2;

        let closestItem;
        let minDistance = Infinity;

        items.forEach((item) => {
          const itemRect = item.getBoundingClientRect();
          const itemCenterX = itemRect.left + itemRect.width / 2;
          const distance = Math.abs(itemCenterX - containerCenterX);

          if (distance < minDistance) {
            closestItem = item;
            minDistance = distance;
          }
        });

        if (closestItem) {
          container.scrollTo({
            left:
              closestItem.offsetLeft -
              container.offsetWidth / 2 +
              closestItem.offsetWidth / 2,
            behavior: 'smooth',
          });
        }
      }, 150); // Adjust this timeout value as needed
    };

    scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className='mt-16 mb-20 px-[3%] md:px-[5%] lg:px-[10%]'>
      <h1 className='text-4xl md:text-5xl text-center font-medium mb-12 text-[#551E19]'>Feature Products</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4" ref={scrollContainerRef}>
        {featureProducts.map((item) => (
          <div className="font-montserrat" key={item._id}>
            <Item
              id={item.id}
              name={item.name}
              image={item.image}
              new_price={item.new_price}
              old_price={item.old_price}
              rating={item.rating}
              reviewText={item.reviewText}
              no_of_rators={item.no_of_rators}
              category={item.category}
              available={item.available}
            />
          </div>
        ))}
      </div>
      <div className='py-6 flex items-center justify-center mt-8'>
        <button onClick={() => navigate('/shop')} className="bg-[#E6B17E] text-[#551e19] px-7 py-3 text-lg rounded-3xl hover:bg-[#c98c3c] flex items-center font-oswald">
          Shop All Products <img src={arrow} className="ml-2 h-4 w-4" />
        </button>
      </div>
      {isLoading && <p className="mt-4">Loading...</p>}
    </div>
  );
};

export default Feature;
